import createVueComponent from '../createVueComponent';

const ArrowLeftCircle = createVueComponent('ArrowLeftCircleIcon', [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['path', { d: 'M16 12H8', key: '1fr5h0' }],
  ['path', { d: 'm12 8-4 4 4 4', key: '15vm53' }],
]);

export default ArrowLeftCircle;
